import React from 'react';
import { Headphones, Briefcase, Heart, Building2, Store, GraduationCap, Truck, Users, Cloud } from 'lucide-react';

const CadenceAudience = () => {
  const industries = [
    { icon: Headphones, name: 'Contact & Call Centers' },
    { icon: Briefcase, name: 'Staffing Centers' },
    { icon: Heart, name: 'Healthcare & Patient-Facing Teams' },
    { icon: Building2, name: 'Banks & Credit Unions' },
    { icon: Store, name: 'Franchise & Multi-Unit Teams' },
    { icon: GraduationCap, name: 'Education & Administration' },
    { icon: Truck, name: 'Logistics & Trucking' },
    { icon: Users, name: 'Consultants & Training Organizations' },
    { icon: Cloud, name: 'Technology Platforms & Cloud Marketplaces' }
  ];

  return (
    <section className="py-20 px-6 bg-gray-900/50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white">
            Where Traain Cadence <span className="text-cyan-400">Excels</span>
          </h2>
          <p className="text-lg text-gray-400">
            Traain Cadence supports high-impact roles where communication matters:
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, index) => {
            const Icon = industry.icon;
            return (
              <div
                key={index}
                className="flex items-center gap-4 p-6 bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 rounded-xl hover:border-cyan-500/30 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-lg bg-cyan-500/10 flex items-center justify-center flex-shrink-0">
                  <Icon className="w-6 h-6 text-cyan-400" />
                </div>
                <p className="text-gray-300 font-medium">{industry.name}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CadenceAudience;
